import { InputAdornment, TextField } from "@mui/material"
import { SearchOutlined } from "@mui-symbols-material/w300"
import React, { type ChangeEvent } from "react"

interface SearchInputProps {
  placeholder?: string
  defaultValue?: string
  value?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  className?: string
  iconPosition?: "start" | "end"
  "data-testid"?: string
}

const SearchInput: React.FC<SearchInputProps> = ({
  placeholder,
  defaultValue,
  value,
  onChange,
  className,
  iconPosition = "start",
  "data-testid": testId = "search-input",
}) => {
  const iconAdornment = (
    <InputAdornment position={iconPosition}>
      <SearchOutlined className='text-gray-600' />
    </InputAdornment>
  )

  return (
    <TextField
      data-testid={testId}
      variant='outlined'
      placeholder={placeholder ?? "Search..."}
      size='small'
      defaultValue={defaultValue}
      value={value}
      onChange={onChange}
      className={className}
      slotProps={{
        input: iconPosition === "start" ? { startAdornment: iconAdornment } : { endAdornment: iconAdornment },
      }}
    />
  )
}

export default SearchInput
